import React from 'react'
import MessageModal from '../MessageModal/MessageModal'
import PropTypes from 'prop-types'

const ExpiredRequestsBanner = ({ setShowBanner }) => {
    const handleContinue = () => {
        setShowBanner(false)
        localStorage.setItem('expiredRequestsShown', 'false')
    }

    return (
        <MessageModal
            isOpen={true}
            title={'Expired Requests'}
            message={
                'Due to inactivity, some of your offline requests have expired. Please connect to the internet frequently to prevent data loss.'
            }
            textDone={'Continue'}
            onDone={handleContinue}
            maxWidth="xl"
        />
    )
}

ExpiredRequestsBanner.propTypes = {
    setShowBanner: PropTypes.func.isRequired,
}

export default ExpiredRequestsBanner
